<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 2/1/2023
  -->

<template>
	<div ref="root" class="qw-img-root">
		<div class="qw-img-media">
			<img ref="img" v-bind="$attrs" :src="srcComputed"/>
		</div>
		<div
			v-if="descriptionSecondaryComputed && showDescription"
			class="image-description-overlay image-description-overlay-top">
			<div
				class="image-description-secondary"
				v-html="descriptionSecondaryComputed"/>
		</div>
		<div
			v-if="descriptionComputed && showDescription"
			class="image-description-overlay image-description-overlay-bottom">
			<div
				class="image-description-primary"
				v-html="descriptionComputed"/>
		</div>
		<LoadingIndicator/>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import QwoachFile from "@shared/Drive/QwoachFile";
import QwoachFileMetadataManager from "@/core/modules/coach/Resources/Files/QwoachFileMetadataManager";

export default {
	name: "QwImg",
	components: {LoadingIndicator},
	extends: BaseComponent,

	props: {
		src: String,
		qwoachFile: QwoachFile,
		description: String,
		showDescription: {type: Boolean, default: true},
		loadingIndicator: {Number, default: 0},
	},

	inheritAttrs: false,

	data() {
		return {
			classes: null,
			descriptionSecondaryHtml: "",
			qwoachFileMetadataManager: null,
		}
	},

	watch: {
		qwoachFile() {
			this.syncMetadataManagerBinding()
		},
	},

	created() {
		this.qwoachFileMetadataManager = new QwoachFileMetadataManager()
	},

	mounted() {
		// this.classes = this.$refs.root.getAttribute("class")
		// this.$refs.root.removeAttribute("class")
		this.setImgListeners()
		this.syncMetadataManagerBinding()
	},

	beforeUnmount() {
		this.qwoachFileMetadataManager.unmount(this.qwoachFile, this)
	},

	methods: {
		setImgListeners() {
			let img = this.$refs.img
			if (!img.complete) {
				this.setLoadingState(true)
				img.addEventListener('load', () => this.setLoadingState(false))
				img.addEventListener('error', (error) => this.setLoadingState(false, error))
			}
		},

		syncMetadataManagerBinding() {
			if (this.qwoachFileMetadataManager) {
				this.qwoachFileMetadataManager.mount(this.qwoachFile, this)
			}
		},

		getImgElement() {
			return this.$refs.img
		},

		setLoadingState(isLoading, error) {
			console.log("setLoadingState: ", ...arguments)
			this.$emit("loadingStateChanged", isLoading, error)
			this.imageLoadingStateChanged(isLoading, error)
		},

		imageLoadingStateChanged(isLoading, error) {
			if (isLoading) {
				this.showProgress()
			} else if (error) {
				console.log("imageLoadingStateChanged: ", error)
				this.hideProgressFail()
				if (error) {
					this.toastWarn("Cannot load image")
				}
			} else {
				this.hideProgress()
			}
		},

	},

	computed: {
		srcComputed() {
			return this.src || this.qwoachFile?.url || null
		},

		descriptionComputed() {
			return this.qwoachFile?.description || this.description || ""
		},

		descriptionSecondaryComputed() {
			return this.descriptionSecondaryHtml || ""
		},
	}
}
</script>

<style lang="scss">
.qw-img-root {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 100%;
	width: 100%;
	height: 100%;

	.qw-img-media {
		position: relative;
		display: inline-block;
		max-width: 100%;
		//max-height: 100%;

		img {
			display: block;
			max-width: 100%;
			max-height: 100%;
		}
	}

	.image-description-overlay {
		position: absolute;
		left: 0;
		right: 0;
		padding: 8px;
		font-size: 10px;
		line-height: 1.3;
		color: #000;
		z-index: 1;
	}

	.image-description-overlay-top {
		top: 0;
		z-index: 10;
		background: linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95));

		.image-description-secondary {
			opacity: 0.85;
			//font-size: 85%;
		}
	}

	.image-description-overlay-bottom {
		bottom: 0;
		z-index: 0;
		background: linear-gradient(to top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.7));
	}

	.image-description-overlay :deep(a) {
		color: inherit;
		text-decoration: underline;
	}
}

</style>
